define(["../core/l10n", "hyperhtml", "../core/ui"], function (_l10n, _hyperhtml, _ui) {
  "use strict";

  _hyperhtml = _interopRequireDefault(_hyperhtml);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n    <td>\n      <a href=\"", "\">\n        ", "\n      </a>\n    </td>\n    <td>\n      ", "\n    </td>\n  "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["\n  <p>\n    ReSpec is a document production toolchain, with a notable focus on W3C specifications.\n  </p>\n  <p>\n    <a href='https://github.com/w3c/respec/wiki'>Documentation</a>,\n    <a href='https://github.com/w3c/respec/issues'>Bugs</a>.\n  </p>\n  <table border=\"1\" width=\"100%\" hidden=\"", "\">\n    <caption>\n      Loaded plugins\n    </caption>\n    <thead>\n      <tr>\n        <th>\n          Plugin Name\n        </th>\n        <th>\n          Processing time\n        </th>\n      </tr>\n    </thead>\n    <tbody>", "</tbody>\n  </table>\n"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  // window.respecVersion is added at build time (see tools/builder.js)
  window.respecVersion = window.respecVersion || "Developer Edition";
  const div = document.createElement("div");

  const render = _hyperhtml.default.bind(div);

  const button = _ui.ui.addCommand("About ".concat(window.respecVersion), show, "Ctrl+Shift+Alt+A", "ℹ️");

  function show() {
    _ui.ui.freshModal("".concat(_l10n.l10n[_l10n.lang].about_respec, " - ").concat(window.respecVersion), div, button);

    const entries = [];

    if ("getEntriesByType" in performance) {
      performance.getEntriesByType("measure").sort((a, b) => b.duration - a.duration).map(({
        name,
        duration
      }) => {
        const humanDuration = duration > 1000 ? "".concat(Math.round(duration / 1000.0), " second(s)") : "".concat(duration.toFixed(2), " milliseconds");
        return {
          name,
          duration: humanDuration
        };
      }).map(perfEntryToTR).forEach(entry => {
        entries.push(entry);
      });
    }

    render(_templateObject(), entries.length ? false : true, entries);
  }

  function perfEntryToTR({
    name,
    duration
  }) {
    const render = _hyperhtml.default.bind(document.createElement("tr"));

    const moduleURL = "https://github.com/w3c/respec/tree/develop/src/".concat(name, ".js");
    return render(_templateObject2(), moduleURL, name, duration);
  }
});
//# sourceMappingURL=about-respec.js.map